@if (dataForCard.length > 0) {
  @for (data of dataForCard; track data) {
    <div class="card">
      <div class="resource_banner_container resource_banner_card d-flex">
        @if (!this.file_id) {
          <div class="_wf-pb-left-container">
            <img class="" id="" src="./assets/images/user-profile-image.png" alt="">
          </div>
        }
        @if (this.file_id) {
          <div>
            @for (sf of selectedFiles; track sf) {
              <div class="">
                @if (showImage(sf)) {
                  <div class="_wf-pb-left-container">
                    <img id="output" class="uploaded-img" [src]="sf.imageSrc | safeHtml"
                      style="width: 100%; height: 100% !important;" />
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (this.action!=undefined && this.action =='MODIFY') {
          <div class="row float-left mr-1">
            <img alt="" (click)="showUserImageUpload()" class="" src="./assets/images/icons/edit.png" style="position: absolute;width: 25px;height: 25px;bottom: 2px;left: 70px;">
          </div>
        }
        <div class="right-content-container">
          <div class="resource_content_container float-left">
            <div class="d-flex align-items-center mb-2">
              @if (data.display_name && data.display_name != undefined) {
                <div class="resource_name">
                {{data.display_name}}</div>
              }
              @if (data.age != undefined && data.gender != undefined) {
                <div class="resource_age rtext-12">
                {{data.age}} | {{data.gender_name}}</div>
              }
            </div>
            <div class="d-flex align-items-center">
              @if (data.telecom != undefined) {
                <div class="flex-fill">
                  <div class="rtext-12">Mob No.</div>
                  <div class="txt-bold-14">{{data.telecom}}</div>
                </div>
              }
              <!-- <div class="flex-fill" *ngIf="data.birthDate">
              <div class="rtext-12">DOB</div>
              <div class="txt-bold-14">{{data.birthDate}}</div>
            </div> -->
            @if (data.emailid != undefined) {
              <div class="flex-fill">
                <div class="rtext-12">Email ID.</div>
                <div class="txt-bold-14">{{data.emailid}}</div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
}